import {
  FC,
  createContext,
  useContext,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { AnimatePresence } from 'framer-motion'

import { Loader } from 'components/loader'
import { strings } from 'lang/strings'
import { config } from 'config'

export type AppContextType = {
  strings: typeof strings.en & typeof strings.ps & typeof strings.prs
  logoUrl: string
}

const LOGOS = {
  ps: require('assets/logo-pashto.svg').default,
  en: require('assets/logo-pashto.svg').default,
  prs: require('assets/logo-dari.svg').default,
}

const AppContext = createContext<AppContextType | null>(null)

export const AppContextProvider: FC<{
  children?: ReactNode | ReactNode[]
}> = ({ children }) => {
  const [isLoading, setLoading] = useState(true)
  const [data, setData] = useState<AppContextType>({
    strings: {} as AppContextType['strings'],
    logoUrl: '',
  })

  const fetchData = async () => {
    // const d = await fetch(`${process.env.PUBLIC_URL}/data.json`, {
    //   cache: 'no-cache',
    // })
    //   .then(res => res.text())
    //   .then(res => {
    //     return JSON.parse(res.replaceAll(/\n/g, ''))
    //   })

    setData({
      strings: strings[config.language],
      logoUrl: LOGOS[config.language],
    })
  }

  const handleLoad = async () => {
    await Promise.all([
      fetchData(),
      new Promise(resolve => {
        setTimeout(resolve, 500)
      }),
    ])

    setLoading(false)
  }

  useEffect(() => {
    void handleLoad()
  }, [])

  return (
    <AppContext.Provider value={data}>
      <AnimatePresence mode="wait">{isLoading && <Loader />}</AnimatePresence>
      {!isLoading && children}
    </AppContext.Provider>
  )
}

export const useAppContext = () => {
  const context = useContext(AppContext)
  return context as AppContextType
}
